

import { Injectable } from '@angular/core';
import { CallNumber } from '@awesome-cordova-plugins/call-number/ngx';
import { EXTERNAL_URLS } from '../constants';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ContextService } from './ctx.service';
import { InfoCopyComponent } from '../components/info-copy/info-copy.component';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  constructor(
    private callNumber: CallNumber,
    public ctx: ContextService,
    private snackBar: MatSnackBar,

  ) { }

  capitalize(str: string): string {
    str = str.toLowerCase();
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  formatSliderLabelKm(v: string): string {
    return `${v} km`;
  }

  openExternalUrl(url: string, newTab = true) {
    window.open(url, newTab ? '_blank' : '_self');
  }

  getKmDistance(value: string): string {
    const meters = Number(value);
    return meters < 1000
      ? Math.round(Number(meters)) + 'm'
      : parseFloat((Number(meters) / 1000).toString()).toFixed(2) + 'km';
  }

  callPhone(phone: string) {
    this.callNumber.callNumber(phone, true)
      .then(res => console.log('Launched dialer!', res))
      .catch(err => console.log('Error launching dialer', err));
  }

  clone(obj) {
    return JSON.parse(JSON.stringify(obj));
  }

  navToCalculateHealthFee() {
    this.openExternalUrl(EXTERNAL_URLS.CALCULATE_HEALTH_FEE);
  }

  navToCallMeBack() {
    this.openExternalUrl(EXTERNAL_URLS.CALL_ME_BACK);
  }

  navToCalculateDentalFee() {
    this.openExternalUrl(EXTERNAL_URLS.CALCULATE_DENTAL_FEE)
  }

  createAnchorTag(
    file: string | Blob,
    name: string,
    open?: boolean
  ) {
    if (window.navigator && (window as any).navigator.msSaveOrOpenBlob) {
      // EDGE support
      (window as any).navigator.msSaveOrOpenBlob(file as Blob, name);
    } else {
      if (file instanceof Blob) {
        file = URL.createObjectURL(file);
      }
      const link = document.createElement('a');
      link.href = file;
      if (open) {
        link.target = '_blank';
      } else {
        link.download = name;
      }
      (link.attributes as any).analyticsDisable = true;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }

  isDivisibleBy(number, x) {
    return (number % x == 0);
  }

  ellipsis(str, length: number): string {
    if (str.length <= length) return str;
    return str?.slice(0, length)?.trimEnd() + '...';
  }

  showOnlineMeeting(data, state) {
    const searchEngineType = ['emergency-center', 'diagnostic-test', 'additional-services'];
    return data?.indCitaOnline && !searchEngineType.includes(state.searchEngineType);
  }

  showEmergencyLabel(data, state) {
    const searchEngineType = ['emergency-center', 'additional-services'];
    return data?.indUrgencias && !searchEngineType.includes(state.searchEngineType);
  }

  copyPhone() {
    this.snackBar.openFromComponent(InfoCopyComponent, {
      duration: 2 * 1000,
      verticalPosition: this.ctx.isDesktop ? 'top' : 'bottom',
      panelClass: 'blue-snackbar'
    });
  }
}


